import I18n from 'I18n';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { getEarlyRequesterResultPromise } from '../utils/getEarlyRequesterResultPromise';
import { useMemo } from 'react';
const STRING_COLLATOR = window.Intl && typeof window.Intl === 'object' && new Intl.Collator();
const getTranslatedLanguageOptions = languagesData => {
  return languagesData.reduce((acc, {
    tag
  }) => {
    // @ts-expect-error lookup isn't typed
    if (I18n.lookup(`SharedI18nStrings.languageNames.${tag}`)) {
      acc.push({
        label: I18n.text(`SharedI18nStrings.languageNames.${tag}`),
        value: tag,
        hidden: false,
        displayOrder: -1
      });
      return acc;
    }
    return acc;
  }, []).sort(({
    label: option1Text
  }, {
    label: option2Text
  }) => {
    if (STRING_COLLATOR) {
      return STRING_COLLATOR.compare(option1Text, option2Text);
    } else if (option1Text > option2Text) {
      return 1;
    } else if (option2Text > option1Text) {
      return -1;
    }
    return 0;
  });
};
const LanguagesQuery = registerQuery({
  fieldName: 'languages',
  fetcher: async () => {
    const {
      objects
    } = await getEarlyRequesterResultPromise({
      name: 'fetch-supported-languages',
      retryRequest: () => http.get('cos-domains/v1/domain-setup-tasks/supported-languages')
    });
    return {
      objects,
      propertyOptions: getTranslatedLanguageOptions(objects)
    };
  }
});
const useLanguages = () => {
  const {
    data,
    loading,
    error
  } = useQuery(LanguagesQuery);
  return useMemo(() => ({
    languages: (data === null || data === void 0 ? void 0 : data.languages.objects) || [],
    languagePropertyOptions: (data === null || data === void 0 ? void 0 : data.languages.propertyOptions) || [],
    languagesLoading: loading,
    languagesError: error
  }), [data, error, loading]);
};
export default useLanguages;